import React, {useRef, useState} from 'react'
import {GiftshopResendDataType, GiftshopResendModalState} from 'types'
import {useGiftShopResendRevisionHandler, useLocation} from 'utils'

import {useSelector} from 'lib/redux'
import GiftShopResendRevisionScreenImage from './GiftShopResendRevisionScreenImage'
import GiftShopResendRevisionScreenVideo from './GiftShopResendRevisionScreenVideo'

export default function GiftShopResendRevisionScreen() {
  const {username} = useSelector('user') || {}
  const {
    collectorNickname,
    contentId,
    invoiceId,
    collectorId,
    contentType,
  } = useLocation('giftshop_resend_revision').state
  const stateRevisionData = useState<GiftshopResendDataType>()
  const ref = useRef<HTMLInputElement>(null)
  const stateResendModal = useState<GiftshopResendModalState>('none')
  const stateSuccess = useState(0)
  const {uploadRevision} = useGiftShopResendRevisionHandler()
  const stateLoadingImg = useState(false)
  const stateLoadingBtn = useState(false)

  return contentType === 'photo' ? (
    <GiftShopResendRevisionScreenImage
      collectorId={collectorId}
      collectorNickname={collectorNickname}
      contentId={contentId}
      inputRef={ref}
      invoiceId={invoiceId}
      stateLoadingBtn={stateLoadingBtn}
      stateLoadingImg={stateLoadingImg}
      stateResendModal={stateResendModal}
      stateSuccess={stateSuccess}
      stateRevisionData={stateRevisionData}
      uploadRevision={uploadRevision}
      username={username}
    />
  ) : (
    <GiftShopResendRevisionScreenVideo
      collectorId={collectorId}
      collectorNickname={collectorNickname}
      contentId={contentId}
      inputRef={ref}
      invoiceId={invoiceId}
      stateLoadingBtn={stateLoadingBtn}
      stateLoadingImg={stateLoadingImg}
      stateResendModal={stateResendModal}
      stateSuccess={stateSuccess}
      stateRevisionData={stateRevisionData}
      uploadRevision={uploadRevision}
      username={username}
    />
  )
}
